import ActivateCardModal from './components/ActivateCardModal';

export const modals = {
  ACTIVATE_CARD: ActivateCardModal
};

export default modals;
